module.exports = __webpack_public_path__ + "img/Simple Yellow.1887a2a7.jpg";